import http from "infra/http";
import { useQuery } from "react-query";
import { ListaRelatorioPrestacaoContasResponse } from "../typings";
import { PaginateResult } from 'core/resources/types/shared';


function useListaRelatoriosPrestacaoContas(params?: {page?: number; search?: string;}) {
  const queryResult = useQuery([`/v1/relatorios/financeiro/prestacao-contas`, params], async () => {
    const { data } = await http.get<PaginateResult<ListaRelatorioPrestacaoContasResponse>>(`/v1/relatorios/financeiro/prestacao-contas`, {
      params
    });

    return data;
  });

  return queryResult;
}

export default useListaRelatoriosPrestacaoContas;
